import React from 'react';
import { Star } from 'lucide-react';
import {
  Section,
  SectionContent,
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  TestimonialItem,
  TestimonialQuote,
  TestimonialAuthor,
  StarRating,
} from '../styles/sections';
import { TestimonialsMarqueeWrapper, TestimonialsMarqueeTrack } from '../styles/marquee';

const testimonials = [
  {
    quote:
      '"Honestly it\'s just made the whole fines thing so much easier. No more chasing people for cash, everyone just pays through the app. Takes about two seconds."',
    author: '\u2013 Alfie Rutherford',
    rating: 5,
  },
  {
    quote:
      '"it\'s made everything so much easier. Everyone can see what\'s in the pot, and unpaid fines double automatically. It sorts itself out."',
    author: '\u2013 Jordan Raguette',
    rating: 5,
  },
  { quote: '"Best decision for team accountability!"', author: '\u2013 Tasha Merchant', rating: 5 },
  { quote: '"Playfair keeps us motivated every match!"', author: '\u2013 Alex Rodriguez', rating: 5 },
  { quote: '"Seamless and fun\u2014highly recommend!"', author: '\u2013 Verity M.', rating: 5 },
  { quote: '"Transformed how we handle team fines."', author: '\u2013 Salem B.', rating: 5 },
];

// Duplicated so the track can loop seamlessly at a -50% translate.
const marqueeTestimonials = [...testimonials, ...testimonials];

function Testimonials() {
  return (
    <Section id="testimonials" backgroundColor="#341cff">
      <SectionContent>
        <SectionSubtitle>Voices from the Pitch</SectionSubtitle>
        <SectionTitle style={{ color: '#fff' }}>Our Community Speaks</SectionTitle>
        <SectionDescription style={{ color: '#fff' }}>
          Hear from teams who have transformed their management with Playfair.
        </SectionDescription>
      </SectionContent>

      <TestimonialsMarqueeWrapper>
        <TestimonialsMarqueeTrack>
          {marqueeTestimonials.map((t, i) => (
            <TestimonialItem key={`${t.author}-${i}`} whileHover={{ scale: 1.02 }}>
              <StarRating>
                {Array.from({ length: 5 }, (_, starIndex) => (
                  <Star
                    key={starIndex}
                    size={20}
                    fill={starIndex < t.rating ? '#F4D047' : 'none'}
                    stroke={starIndex < t.rating ? '#F4D047' : '#d1d5db'}
                  />
                ))}
              </StarRating>
              <TestimonialQuote>{t.quote}</TestimonialQuote>
              <TestimonialAuthor>{t.author}</TestimonialAuthor>
            </TestimonialItem>
          ))}
        </TestimonialsMarqueeTrack>
      </TestimonialsMarqueeWrapper>
    </Section>
  );
}

export default Testimonials;
